import React, { useEffect, useState } from 'react'
import {
    Select,
    Form,
    Button,
    message,
    Tooltip,
    Switch,
    Checkbox,
    Space,
    Spin,
    Input
} from 'antd'

import {
    DownloadOutlined,
    QuestionCircleOutlined
} from '@ant-design/icons'

import axios from 'axios'
import { serverUrl } from '../../Constants'
import { useApi, useMobile } from '../../Utils'

export const pad = (n: any, width: any, z = '0') => {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export default function ReportPEStock() {
    const [loading, setLoading] = useState(false)
    const [form] = Form.useForm()
    const isMobile = useMobile()
    const { data, loading: _loading } = useApi<any>('get', 'v3/pe/comunes/infoRpt')

    const [availableProcess, setAvailableProcess] = useState<any[]>([])
    const [brands, setBrands] = useState<any[]>([])

    useEffect(() => {
        if (data?.almacenes) {
            setAvailableProcess(data.almacenes)
            setBrands(data.marcas.map((m:any) => {
                return {
                    value: m.Codigo,
                    label: m.Nombre
                }
            }))
        }
    }, [data])

    useEffect(() => {
        setLoading(_loading)
    }, [_loading])

    const { Option } = Select

    const onFinish = (data: any) => {
        setLoading(true)
        console.log(data)
        // setLoading(false)
        axios({
            method: 'post',
            url: `${serverUrl}v3/pe/rpt/stock`,
            responseType: 'blob',
            data
        }).then((response) => {
            let stringDate = "" + new Date().getFullYear() + pad(new Date().getMonth() + 1, 2) + pad(new Date().getDate(), 2);
            // @ts-ignore
            if (!window.navigator.msSaveOrOpenBlob) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'PE' + stringDate + ' Stock.xlsx');
                document.body.appendChild(link);
                link.click();
            } else {
                // @ts-ignore
                window.navigator.msSaveOrOpenBlob(new Blob([response.data]), 'PE' + stringDate + ' Stock.xlsx');
            }
            setLoading(false)
        }).catch(async (err) => {
            const blob = err.response.data

            const text = await blob.text();
            const json = JSON.parse(text);

            if (json.message === "array_keys() expects parameter 1 to be array, null given") {
                message.warning('La consulta solicitada no tiene información, cambia los filtros e intenta nuevamente.', 15)
            } else {
                message.error('Ha ocurrido un error al descargar el reporte, intente nuevamente.', 10)
            }
            setLoading(false)
        })
    }

    return <Form labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} form={form} onFinish={onFinish} initialValues={{
        year: `${new Date().getFullYear()}`,
        withLote: false,
        scope: "code",
        scopeText: '',
        scopeBrands: [] 
        // year: `${new Date().getFullYear()}${pad(new Date().getMonth() + 1, 2)}`
    }}>
        <p>Para generar un reporte de stock, debes seleccionar el tipo de informe, el/los almacenes de origen y filtros opcionales.</p>
        <br />
        <Form.Item name="reportType" label="Tipo de Reporte" required rules={[
            { required: true, message: 'Debes seleccionar un tipo de reporte.' }
        ]}>
            <Select
                disabled={loading}
                // showSearch
                // allowClear
                placeholder='Selecciona un tipo de reporte'
            >
                <Option value={"withStock"} key={"withStock"}>Artículos con Stock</Option>
                <Option value={"outStock"} key={"outStock"}>Artículos sin Stock</Option>
                <Option value={"allStock"} key={"allStock"}>Todos los artículos</Option>
                {/* <Option value={"consolidado"} key={"consolidado"}>Stock consolidado</Option>
                <Option value={"perLote"} key={"perLote"}>Stock por Lotes</Option> */}
            </Select>
        </Form.Item>
        <Form.Item name="scope" label={<>Alcance {!isMobile && <>&nbsp;
            <Tooltip placement="right" title="Si no se indica, no filtrará detalles en el informe.">
                <QuestionCircleOutlined />
            </Tooltip></>}</>}>
            <Select
                disabled={loading}
                // showSearch
                // allowClear
                placeholder='Selecciona el alcance del reporte'
            >
                <Option value={"code"} key={"code"}>Código / Artículo</Option>
                <Option value={"brand"} key={"brand"}>Familia / Artículo</Option>
                {/* <Option value={"consolidado"} key={"consolidado"}>Stock consolidado</Option>
                <Option value={"perLote"} key={"perLote"}>Stock por Lotes</Option> */}
            </Select>
        </Form.Item>
        {/* CAMPO EXTRA DEPENDIENDO DEL SCOPE */}
        <Form.Item
            noStyle
            shouldUpdate={(prev, curr) => prev.scope !== curr.scope}
        >
            {({ getFieldValue }) => {
                const scope = getFieldValue("scope");

                if (scope === "code") {
                    return (
                        <Form.Item
                            name="scopeText"
                            label="Filtrar por texto"
                            tooltip="Ej: código, parte del nombre, etc."
                        >
                            <Input
                                disabled={loading}
                                placeholder="Ej: MB005A01DF"
                                allowClear
                            />
                        </Form.Item>
                    );
                }

                if (scope === "brand") {
                    return (
                        <Form.Item
                            name="scopeBrands"
                            label="Marcas"
                            tooltip="Selecciona una o más marcas para filtrar"
                        >
                            <Select
                                disabled={loading}
                                mode="multiple"
                                allowClear
                                showSearch
                                placeholder="Selecciona marca(s)"
                                optionFilterProp="children"
                            >
                                {brands.map((b) => (
                                    <Option key={b.value} value={b.value}>
                                        {b.label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    );
                }

                return null;
            }}
        </Form.Item>
        <Form.Item name="almacenes" label="Almacén/es" required rules={[
            { required: true, message: 'Debes seleccionar al menos un almacén.' }
        ]}>
            <Checkbox.Group
                disabled={loading}
                // placeholder='Selecciona el/los almacén/es'
            >
                {loading && <Space direction="vertical" style={{width:'100%', display: 'flex', flexDirection: 'row'}}>
                    <Spin /> Cargando almacenes...
                </Space>}
                {availableProcess.map(field => (
                    <Space direction="vertical" style={{ width: "100%" }}>
                        <Checkbox value={field.Codigo} key={field.Codigo}>{field.Codigo} - {field.Nombre}</Checkbox>
                    </Space>
                    // <Option value={field.Codigo} key={field.Codigo}>{field.Codigo} - {field.Nombre}</Option>
                ))}
            </Checkbox.Group>
        </Form.Item>
        <Form.Item name="withLote" label={<>Emitir Lotes / Series {!isMobile && <>&nbsp;
            <Tooltip placement="right" title="Incluye en el informe los lotes de los productos indicados.">
                <QuestionCircleOutlined />
            </Tooltip></>}</>}>
            <Switch loading={loading} />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={loading} icon={<DownloadOutlined />} className='Accounting--DownloadBtn' >
            Solicitar Informe
        </Button>
    </Form>
}
